import { render, staticRenderFns } from "./UpDejunForm.vue?vue&type=template&id=5ea6a835&"
import script from "./UpDejunForm.vue?vue&type=script&lang=js&"
export * from "./UpDejunForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports